
// todas as uri da api, precisam ter uma barra no final
const CONSTANTS = {
  API: {
    BASE: process.env.REACT_APP_PORTAL_API || "http://api.codivas.com.br:3000/",
    LOGIN: "/auth/login/",
    REGISTRO: "/users/",
    PROFILE: "/profile",
    USER: "/users",
    RECOVERY: "/auth/recovery"
  },
  APP: {
    /* default home */  HOME_PAGE: "/portal/home",
    LOGIN: "/",
    RECOVERY: "/recovery",
    REGISTER: "/register?target=/portal/profile",
    PROFILE: "/portal/profile",
    SERVICE_UNAVAILABLE: "/service-unavailable" ,
    TERMOS: "/portal/termos",
    POLITICA: "/portal/politica",
    CODIVAS: "/portal/codivas"
  },
  ERROR_MESSAGE: {
    api: (message) => (
      `Falha ao obter dados do servidor, detalhes: "${message}"`
    )
  },
  COLORS: {
    text: 'black',
    background: 'white',
    colorMain: '#78529c',
    colorFont: '#202020',
    colorFontLighter: '#a1a1a1',
    colorHilight: '#71bb73',
    colorBgContent: '#292929'
  }
  
  
};



//CONSTANTS.API.BASE = "http://localhost:8000/"
//CONSTANTS.API.LOGIN = "/login"



export default CONSTANTS;
